/* RESPONSIBLE TEAM: team-standalone */

import type { RequestAccessData } from '../definitions';
import type SalesforcePlatform from '../../salesforce';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';

export default class SalesforceRequestAccessData implements RequestAccessData {
  private platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    this.platform = platform;
  }

  get platformUrl() {
    if (this.platform.salesforceConfig?.instanceUrl) {
      return `${this.platform.salesforceConfig?.instanceUrl}/lightning/o/MessagingSession/list`;
    }
    return undefined;
  }

  get platformName() {
    return this.platform.platformKey;
  }

  get imageUrl() {
    return assetUrl('/assets/images/standalone/copilot-on-salesforce.png');
  }
}
